import * as Sentry from '@sentry/react';

export default (e) => {
  console.error(e);
  Sentry.captureException(e);
};
